import i18n from '@/i18n'

// Types
interface TableHeaderOption {
    label: string
    visibleLabel: string
}

interface TableHeaderGlobalOptions {
    shortText: TableHeaderOption
    fullText: TableHeaderOption
    custom: TableHeaderOption
}

interface TableHeaderColumnOptions {
    iconOnly: TableHeaderOption
    shortText: TableHeaderOption
    fullText: TableHeaderOption
    custom: TableHeaderOption
}

// Base config without visibleLabel - labels are added dynamically via get functions
const tableHeaderGlobalOptionsBase = {
    shortText: {
        label: 'shortText',
        translationKey: 'widget.table.manage.shortTextOption'
    },
    fullText: {
        label: 'longText',
        translationKey: 'widget.table.manage.fullTextOption'
    },
    custom: {
        label: 'custom',
        translationKey: 'widget.table.manage.custom'
    }
}

const tableHeaderColumnOptionsBase = {
    iconOnly: {
        label: 'iconOnly',
        translationKey: 'widget.table.headerIconOnlyOption'
    },
    shortText: {
        label: 'shortText',
        translationKey: 'widget.table.headerShortTextOption'
    },
    fullText: {
        label: 'longText',
        translationKey: 'widget.table.headerFullTextOption'
    },
    custom: {
        label: 'custom',
        translationKey: 'widget.table.headerCustomOption'
    },
}

// Helper function to add translated visibleLabel at runtime
function addVisibleLabel<T extends Record<string, { label: string; translationKey: string }>> (
    options: T
): { [K in keyof T]: TableHeaderOption } {
    const result = {} as { [K in keyof T]: TableHeaderOption }
    for (const key in options) {
        result[key] = {
            label: options[key].label,
            visibleLabel: i18n.t(options[key].translationKey) as string
        }
    }
    return result
}

// Returns options with translated labels - call at runtime when translations are available
export function getTableHeaderGlobalOptions (): TableHeaderGlobalOptions {
    return addVisibleLabel(tableHeaderGlobalOptionsBase)
}

export function getTableHeaderColumnOptions (): TableHeaderColumnOptions {
    return addVisibleLabel(tableHeaderColumnOptionsBase)
}
